import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import AppModal from "components/ui/AppModal/AppModal";
import { iconDemo } from "utils/constants";
// import loginBackVideo from "assets/images/VídeoBackGround.mp4";
import styles from "./auth.module.css";

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    variant: "custom",
    title: "",
    message: "",
    confirmText: "Ok"
  });
  const [afterConfirmRoute, setAfterConfirmRoute] = useState(null);

  const closeFeedbackModal = () =>
    setFeedbackModal(prev => ({ ...prev, open: false }));

  const handleConfirm = () => {
    closeFeedbackModal();
    if (afterConfirmRoute) {
      const route = afterConfirmRoute;
      setAfterConfirmRoute(null);
      navigate(route);
    }
  };

  const verifyEmailToken = async token => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/verify_email?token=${token}`
      );
      setAfterConfirmRoute("/login");
      setFeedbackModal({
        open: true,
        variant: "success",
        title: "E-mail Verificado!",
        message: response.data.message,
        confirmText: "Ok"
      });
    } catch (error) {
      setAfterConfirmRoute("/login");
      setFeedbackModal({
        open: true,
        variant: "error",
        title: "Erro!",
        message: error.response?.data?.error || "Ocorreu um erro desconhecido.",
        confirmText: "Ok"
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verifyEmailToken(token);
  }, [token]);

  return (
    <div className={styles.root}>
{/* <video autoPlay muted loop className={styles.videoBg}>
        <source src={loginBackVideo} type="video/mp4" />
      </video> */}
      <div className={styles.overlay} />

      <div className={styles.card}>
        <div className={styles.logoWrap}>
          <img src={iconDemo} alt="Vertex4D" className={styles.logo} />
        </div>
        <h1 className={styles.title}>Verificação de E-mail</h1>

        <div className={styles.verifyWrap}>
          {loading ? (
            <>
              <div className={styles.spinner} style={{ margin: "0 auto", width: 32, height: 32, borderWidth: 3 }} />
              <p className={styles.verifyText}>Verificando seu e-mail, aguarde...</p>
            </>
          ) : (
            <p className={styles.verifyText}>
              Sua verificação foi processada. Por favor, verifique as notificações para mais informações.
            </p>
          )}
        </div>
      </div>

      <AppModal
        isOpen={feedbackModal.open}
        onClose={closeFeedbackModal}
        allowOutsideClick={true}
        variant={feedbackModal.variant}
        title={feedbackModal.title}
        message={feedbackModal.message}
        confirmText={feedbackModal.confirmText}
        cancelText={null}
        onConfirm={handleConfirm}
        onCancel={closeFeedbackModal}
      />
    </div>
  );
};

export default EmailVerification;
